import { FONT_BASE } from '../constants/AppFonts';

const PIXELS_PER_HEALTH = 0.6;
const PIXEL_DEFAULT = 100;
const PIXELS_MAX = 400;

export class EnemyHealthBar extends Phaser.GameObjects.Container {
  constructor(...args) {
    super(...args);

    this.scene.add.existing(this);
    this._bossHealth = new HealthBar(this.scene);
    this._enemyHealth = new HealthBar(this.scene);
    this._enemyHealth.y = 0;
    this._enemyHealth.scale = 1;
    this._activeBoss = null;
    this.add([this._enemyHealth, this._bossHealth]);
  }

  set target(value) {
    this._enemyHealth.target = value;
  }

  setBoss(value) {
    if (value == this._activeBoss) return;
    if (!value) {
      this.scene.tweens.add({
        targets: this._enemyHealth,
        scaleX: 1,
        scaleY: 1,
        y: 0,
        duration: 250,
      });
    } else {
      this.scene.tweens.add({
        targets: this._enemyHealth,
        scaleX: 0.85,
        scaleY: 0.85,
        y: 75,
        duration: 250,
      });
    }
    this._bossHealth.target = value;
    this._activeBoss = value;
  }

  update() {}
}

class HealthBar extends Phaser.GameObjects.Container {
  constructor(...args) {
    super(...args);

    this.scene.add.existing(this);

    this.nameText = this.scene.add
      .text(-10, 0, '', {
        fontFamily: FONT_BASE.REGULAR,
        fontSize: 28,
        fill: '#FFFFFF',
        align: 'right',
      })
      .setOrigin(1, 0);

    const ty = this.nameText.height + 4;
    this._barRight = this.scene.add.image(0, ty, 'game_graphics', 'enemy_health_right');
    this._barRight.setOrigin(1, 0);
    this._barFill = this.scene.add.image(0, ty, 'game_graphics', 'enemy_health_fill');
    this._barFill.setOrigin(1, 0);
    this._barLeft = this.scene.add.image(0, ty, 'game_graphics', 'enemy_health_left');
    this._barLeft.setOrigin(1, 0);
    this._barMask = this.scene.add.graphics(0);
    this._barMask.y = ty + 3;
    this._barDamage = this.scene.add.graphics(0);
    this._barDamage.y = ty + 3;
    this.add([
      this._barFill,
      this._barLeft,
      this._barRight,
      this.nameText,
      this._barMask,
      this._barDamage,
    ]);

    this.alpha = 0;
  }

  set target(value) {
    if (value === this._target) return;

    if (!value) return this.clearTarget();
    this._target = value;
    this.alpha = 1;
    this._targetHealthLast = this._target.healthPercent;

    this._target.on('DAMAGE_RECIEVED', this.handleDamage, this);

    this._barFill.displayWidth = Math.ceil(
      PIXEL_DEFAULT + Math.min(225, value.healthMax * PIXELS_PER_HEALTH)
    );

    this._barFill.x = this._barRight.x - this._barRight.displayWidth;
    this._barLeft.x = this._barFill.x - this._barFill.displayWidth;
    this._barMask.x = this._barLeft.x - this._barLeft.displayWidth + 5;
    this._barDamage.x = this._barMask.x;
    this._healthBarWidth = this._barFill.displayWidth + 22;

    this.nameText.text = value && value.healthPercent > 0 ? this.scene.game.copy.get(value.id) : '';
    this.visible = true;
    this.updateTargetHealth();
  }

  clearTarget() {
    this._target?.off('DAMAGE_RECIEVED', this.handleDamage, this);
    this._target = null;
    this.scene.tweens.killTweensOf(this);
    if (this.alpha > 0)
      this.scene.tweens.add({
        targets: this,
        alpha: 0,
        duration: 500,
      });
  }

  get displayWidth() {
    return this.panel.displayWidth;
  }

  handleDamage(value) {
    if (!this._target) return;
    const damagePercent = this._targetHealthLast - this._target.healthPercent;
    const damageWidth = damagePercent * this._healthBarWidth;
    this._barDamage.x = this._barMask.x + (1 - this._targetHealthLast) * this._healthBarWidth;
    this.fillBar(this._barDamage, damageWidth, 0xff00c0);
    this._barDamage.damageWidth = damageWidth;
    this.scene.tweens.killTweensOf(this._barDamage);
    this.scene.tweens.add({
      targets: this._barDamage,
      x: '+=' + damageWidth,
      damageWidth: 0,
      duration: 500,
      onUpdate: () => this.fillBar(this._barDamage, this._barDamage.damageWidth, 0xff00c0),
    });
    this.updateTargetHealth();
  }

  updateTargetHealth() {
    this._barMask.clear();

    if (this._target.healthPercent === 1) return;
    const targetWidth = (1 - this._target.healthPercent) * this._healthBarWidth;
    this._targetHealthLast = this._target.healthPercent;
    this.fillBar(this._barMask, targetWidth, 0x002d66);
  }

  fillBar(bar, width, colour, alpha = 1) {
    width = Math.max(0, width - 7);
    bar.clear();
    bar.fillStyle(colour, alpha);
    bar.moveTo(7, 0);
    bar.lineTo(7 + width, 0);
    bar.lineTo(width, 20);
    bar.lineTo(0, 20);
    bar.fill();
  }

  update() {
    if (!this._target) return;
  }
}
